import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import Lnk, { LnkProps } from 'src/navigation/Lnk'
import { css, CSSProp } from 'styled-components'

interface TitledCellProps {
  label: React.ReactElement
  content: React.ReactElement
  isTitle?: boolean
  spreadCells?: boolean
  style?: CSSProp
}

export const TitledCell: React.FC<TitledCellProps> = (
  props,
): React.ReactElement => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        ${props.spreadCells
          ? props.isTitle &&
            css`
              width: 80%;
            `
          : css`
              width: 100%;
            `}
        ${props.style}
      `}
    >
      <span
        css={css`
          ${getFontCss(
            14,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )};
          margin-bottom: 4px;
        `}
      >
        {props.label}
      </span>
      <div
        css={css`
          display: flex;
          flex-direction: row;
          align-items: center;
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            props.isTitle
              ? styleConstants.fontFamilies.medium
              : styleConstants.fontFamilies.regular,
          )};
        `}
      >
        {props.content}
      </div>
    </div>
  )
}

interface ListBoxProps {
  id?: string
  className?: string
  linkProps?: LnkProps
  cells: TitledCellProps[]
  icon?: React.ReactElement | boolean
}

const ListBox: React.FC<React.PropsWithChildren<ListBoxProps>> = (
  props,
): React.ReactElement => {
  const content = (
    <div
      id={props?.id}
      className={props.className}
      css={css`
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 20px;
        border: 1px ${styleConstants.colors.gray_medium} solid;
        border-radius: ${styleConstants.borderRadius.box};
        background-color: ${styleConstants.colors.gray_light};
        ${props.icon === false &&
        css`
          padding-right: 60px;
        `}
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-grow: 1;
        `}
      >
        {props.cells.map((cell: TitledCellProps, i) => (
          <TitledCell key={i} {...cell} spreadCells={props.cells.length <= 2} />
        ))}
      </div>
      {props.icon}
    </div>
  )

  return props.linkProps !== undefined ? (
    <Lnk
      {...props.linkProps}
      css={css`
        width: 100%;
        display: flex;
        &:hover {
          #title {
            color: ${themeConstants.colors.cta};
          }
          #chevron {
            transform: scale(calc(20 / 24)) translateX(4px);
          }
        }
      `}
    >
      {content}
    </Lnk>
  ) : (
    content
  )
}

export default ListBox
